function validDay(day) {
  if (typeof day !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(day)) return false;
  const date = new Date(`${day}T00:00:00Z`);
  return Number.isFinite(date.getTime()) && date.toISOString().slice(0,10) === day;
}
function studentDay(value) {
  if (value instanceof Date) return Number.isFinite(value.getTime()) ? new Date(value.getTime()+330*60000).toISOString().slice(0,10) : '';
  if (typeof value !== 'string') return '';
  const text = value.trim();
  if (validDay(text)) return text;
  if (!/^\d{4}-\d{2}-\d{2}T(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d{1,3})?(?:Z|[+-](?:[01]\d|2[0-3]):[0-5]\d)$/.test(text) || !validDay(text.slice(0,10))) return '';
  const date = new Date(text);
  return Number.isFinite(date.getTime()) ? new Date(date.getTime()+330*60000).toISOString().slice(0,10) : '';
}
export { validDay, studentDay };
